import { BufferAttribute, Mesh, RepeatWrapping, ShaderMaterial, SphereGeometry, TextureLoader } from '@anov/3d-core'
import cloudShader from '../../shaders/cloud'
import type { ICloudOption } from '../../utils/constant'
import { CloudDensity, T_TileNoise, T_soft_smoke } from '../../utils/constant'

const textureLoader = new TextureLoader()

const _defaultOption: ICloudOption = {
  texture1: textureLoader.load(T_soft_smoke),
  texture2: textureLoader.load(T_TileNoise),
  duration: 2,
  cloudDensity: 0.02,
  cloudDensity2: 1.6,
  cloudalpha: 0.8,
  cloudscale: 8.0,
  speed: 0.2,
  color: [0.9, 0.9, 0.9],
  flash: 0.3,
  skyTime: 7.0,
}

class CloudMesh extends Mesh {
  option: ICloudOption = _defaultOption

  uniforms: any = {}
  mesh!: Mesh
  loaded!: Promise<Boolean>

  constructor() {
    super()
    if (this.option.texture1)
      this.option.texture1.wrapS = this.option.texture1.wrapT = RepeatWrapping
    if (this.option.texture2)
      this.option.texture2.wrapS = this.option.texture2.wrapT = RepeatWrapping
    this.setUniforms({
      ...this.option,
      iTime: 0,
    })

    this.geometry = new SphereGeometry(1, 320, 320, 0, Math.PI * 2, 0, 1.5)
    const positions = this.geometry.attributes.position.array
    const uvs = new Float32Array(positions.length / 3 * 2) // 创建新的 UV 数组

    // 重新计算 UV 坐标
    for (let i = 0; i < positions.length / 3; i++) {
      const x = positions[i * 3]
      const z = positions[i * 3 + 2]

      const u = (x * 0.8 + 1) / 2 // 将 x 坐标映射到 [0, 1]
      const v = (z * 0.8 + 1) / 2 // 将 z 坐标映射到 [0, 1]

      uvs[i * 2] = u
      uvs[i * 2 + 1] = v
    }
    // 将新的 UV 坐标添加到几何体
    this.geometry.setAttribute('uv', new BufferAttribute(uvs, 2))

    this.material = new ShaderMaterial({
      uniforms: this.uniforms,
      vertexShader: cloudShader.vertexShader,
      fragmentShader: cloudShader.fragmentShader,
      side: 2,
      transparent: true,
      depthWrite: false,
    })
    // this.position.y = -2000
    // this.scale.set (19990, 6000, 19990)
  }

  /**
         * 设置天气的Uniforms
         * @param option
         */
  private setUniforms(option: ICloudOption) {
    Object.assign(this.option, option)

    Object.keys(option).forEach((key: string) => {
      this.uniforms[key] = { value: option[key] }
    })
  }

  setTime(time: number) {
    this.setUniforms({ skyTime: time })
    // console.log(time)
    // this.setUniforms({ skyTime: time.toFixed(1) })
  }

  public setAlpha(alpha: number) {
    this.setUniforms({ cloudalpha: alpha })
  }

  public setScale(scale: number) {
    this.setUniforms({ cloudscale: scale })
  }

  public setSpeed(speed: number) {
    this.setUniforms({ speed })
  }

  public setFlash(flash: number) {
    this.setUniforms({ flash })
  }

  public setEffect(type: string, ops: ICloudOption) {
    const density = CloudDensity[type] || {}
    this.setUniforms({ ...density, ...ops })
  }

  public update() {
    const { iTime } = this.uniforms
    iTime.value += 0.005
  }
}

export default CloudMesh